import { userService } from "../services";
import config from "../config/config";

export const UserIdApprover = {
  fetchApprover,
  fetchApproverList,
  deletArroved,
  fetchMultiLevelApproverList,
  fetchMultiLevelApproverListForEndUser,
};

async function fetchApprover(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.userApprover}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      // return response.data;
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}

async function fetchApproverList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getAllApprover}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function deletArroved(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.deleteAppover}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      // return response.data;
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.log("error", error);
    return error;
  }
}

async function fetchMultiLevelApproverList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getAllMultiLevelApproverForCompanyDetails}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchMultiLevelApproverListForEndUser(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getAllMultiLevelApproverForCompanyDetailsV3}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
